import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import formDefault from "../../docs/formDefault.json";
import { FormBase } from "commonAssets/components/FormBase";
import { createElement } from "commonAssets/lib/createElement";
import { modal } from "commonAssets/lib/modal";
import { loadingGif } from "commonAssets/lib/loadingGif";
import { validateField } from "commonAssets/lib/validateField";
import { clearMessage } from "commonAssets/lib/clearMessage";
import { toggleFieldError } from "commonAssets/lib/toggleFieldError";
import { loadMember } from "commonAssets/lib/loadMember";
import { ConfirmEmailAddress } from "commonAssets/lib/ConfirmEmailAddress";
import { localDatetime } from "commonAssets/lib/localDatetime";
import { generateMd5Hash } from "commonAssets/lib/generateMd5Hash";
import { toggleFieldWarning } from "commonAssets/lib/toggleFieldWarning";
import { removeClaimFile } from "commonAssets/lib/removeClaimFile";
import { uploadFile } from "commonAssets/lib/uploadFile";
import { validOTP } from "commonAssets/lib/validOTP";
import { createOTPForm } from "commonAssets/lib/createOTPForm";
import { uniformClaimDeadline } from "commonAssets/lib/uniformClaimDeadline";
import {
    i18n,
    loading,
    outputDiv,
    reCAPTCHAv3,
    appConfigDev,
    appConfigKey,
    appConfigProd,
    appPayMethod,
    appDomain,
    claimForm,
    claimMethod,
    userLanguage,
} from "commonAssets/js/constants";
import {
    dstPaymentIframeTitle,
    dstMember,
    dstProcess,
} from "commonAssets/components/FormBase/DigitalDisbursements";
import { formatPhone } from "commonAssets/lib/formatPhone";
import { toggleFieldAttributeV2 } from "commonAssets/lib/toggleFieldAttributeV2";
import { toggleForeignPhone } from "commonAssets/lib/toggleForeignPhone";
import { DigitalDisbursements } from "commonAssets/components/FormBase/DigitalDisbursements";
import {
    FormFields,
    FormFieldsLabel,
} from "commonAssets/components/FormBase/FormFields";
import { ErrorHandler } from "commonAssets/utils/ErrorHandler";

export class customSubmitClaim extends SubmitClaim {
    async form() {
        const form = formDefault.claim_form[this.lang];
        this.init_claim(form);
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customSubmitClaim(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }

    claim_instructions(params) {
        if (
            params.form_options.claim_form.general_instructions.display ===
            false
        ) {
            return createElement("div", { class: "d-none" });
        }
        return createElement(
            "div",
            {
                class: "mb-3",
                id: "generalInstructionsWrapper",
            },
            [
                createElement(
                    "div",
                    {
                        id: "generalInstructions",
                    },
                    [
                        createElement(
                            "div",
                            {
                                class: "bg-light text-dark border rounded p-3 mb-3",
                            },
                            [
                            createElement(
                                    "div",
                                    {
                                        class: "",
                                    },
                                    [
                                        createElement(
                                            "div",
                                            {
                                                class: "h3 mb-3 formTitle"
                                            },
                                            [],
                                            params.form_options.claim_form.general_instructions
                                                .title
                                        ),
                                    ]
                                ),
                                createElement("div", {}, [], params.form_options.claim_form.general_instructions.body)
                            ]
                        ),
                    ]
                ),
            ]
        );
    }

    claim_form(params, additionalParams) {
        console.log("[claim_form]")
        // update the claim form deadline
        const deadline_heading = params.form_options.claim_deadline_alert.claim_form;
        const deadline_parser = new DOMParser();
        const deadline_string = deadline_parser.parseFromString(deadline_heading, "text/html");
        const deadline_date_string = deadline_string.querySelector("span");
        // if deadline_date_string is null, then the deadline is not set
        // the if condition was added due to error in i18n translation
        // TODO: remove this if condition after fixing the i18n translation
        if (deadline_date_string !== null) {
            deadline_date_string.textContent = additionalParams;
        }

        // const the form
        const form = createElement("form", {
            class: "needs-validation",
            id: "form",
            method: "post"
        }, [
            createElement("h3", {
                class: "text-center mb-3",
                id: "claimFormDeadline"
            }, [], deadline_string.body.innerHTML),
            createElement("div", {
                class: "alert alert-info text-center fw-bold text-dark",
                id: "confirmation-email-alert",
                role: "alert"
            }, [], params.form_options.claim_form.confirmation_email_notice),
            this.claim_instructions(params),
            this.claim_contact_information(params),
            this.claim_fieldset(params),
            //params.claim_transactions ? this.claim_transactions(params) : ``,
            params.claim_upload.documentation.required ? this.claim_documentation(params) : ``,
            appPayMethod ? DigitalDisbursements(params) : ``,
            this.claim_certification(params),
        ]);
        return form;
    }

    claim_fieldset(params) {
        if (params.claim_fields_sectioned === undefined) {
            return createElement("div", { class: "d-none" });
        }
        if (params.claim_fields_sectioned.length === 0) {
            return createElement("div", { class: "d-none" });
        }
        const claimFields = createElement("div", {
            id: "claim-fields"
        }, [
            this.claim_field_sections(params)
        ])
        return claimFields;
    }

    claim_field_sections(params) {
        const claimFieldSections = createElement("div", {});

        params.claim_fields_sectioned.forEach((section) => {
            claimFieldSections.append(createElement("fieldset", { class: "bg-light text-dark border rounded p-3 mb-5" }, [
                createElement("div", { class: "h3 mb-3 formTitle" }, [], section.title),
                createElement("div", { class: "mb-3 formBody" }, [], section.body),
                this.claim_fields(section.fields),
                section.transactions ? this.claim_transactions(params, section.transaction_id) : ``
            ]))
        })
        return claimFieldSections;
    }

    claim_fields(fields) {
        const container = createElement("div");

        let fieldID = 0;  //
        fields.forEach(field => {
            let element;
            let validation;
            let className = field.className ? field.className : ``;

            const div = createElement("div", {
                class: (field.parentClass ? field.parentClass : "mb-3 _wrapper"),
                "data-field-id": "_" + (field.name ? field.name : "_wrapper_" + fieldID)
            });
            element = FormFields(field, className, fieldID, element, validation, container);
            FormFieldsLabel(field, fieldID, div);

            div.append(element);
            container.appendChild(div);
            fieldID++;
        });

        return container;
    }

    claim_transactions(params, transaction_id) {
        if (params.claim_transactions === undefined) {
            return createElement("div", { class: "d-none" });
        }
        if (params.claim_transactions.length === 0) {
            return createElement("div", { class: "d-none" });
        }

        const fieldset = createElement("div", {
            class: "bg-light text-dark border rounded p-3 mb-5",
            id: `transactions-${transaction_id}`
        }, [
            // createElement("div", {
            //     class: "h3 mb-3 formTitle",
            // }, [], params.form_options.transactions.title),
            // createElement("div", {
            //     class: "mb-3 formBody"
            // }, [], params.form_options.transactions.body),
        ]);

        // For Each Transaction Table
        const claim_transactions = params.claim_transactions;
        let tableID = 0;
        claim_transactions.forEach(table => {
            tableID++; // Begin count at 1.
            if (tableID != transaction_id) return;

            // <div class="table-responsive"></div>
            const divResponsiveTable = createElement("div", { class: "table-responsive mb-3", id: "table_responsive_" + tableID });

            // <table class="table transactions"></table>
            const tableTransaction = createElement("table", {
                class: "table table-hover transactions caption-top",
                id: "transactions_" + tableID,
                "data-table-name": table.name,
                "data-table-id": tableID,
            }, [
                //createElement("caption", { class: "text-dark bg-transparent" }, [], "<strong>" + table.name + "</strong> &mdash; " + table.description),
            ]);
            divResponsiveTable.appendChild(tableTransaction);

            // <thead class="bg-dark text-light"></thead>
            const tableTHEAD = createElement("thead", { class: "table-dark text-light" });
            tableTransaction.appendChild(tableTHEAD);

            // <tr> ...Table Data Cells... </tr>
            const theadTR = createElement("tr");
            tableTHEAD.appendChild(theadTR);

            // <th scope="col"></th>
            table.columns.forEach(col => {
                const column = createElement("th", { scope: "col" }, [], col.title);
                theadTR.appendChild(column);

                if (Boolean(col.body)) {
                    const helper = createElement("span", { class: "d-block fw-normal", style: "font-size:16px;" }, [], col.body);
                    column.appendChild(helper);
                }
            });

            // <tbody></tbody>
            const tableTBODY = createElement("tbody");
            tableTransaction.appendChild(tableTBODY);

            // Add rows through a function, so we can attach a button.
            let countRow = 1;
            this.claim_transaction_row(table, tableTBODY, tableID, countRow);

            const add_row = createElement("div", {
                class: "text-center",
            }, [
                createElement("a", {
                    class: "btn btn-primary m-1",
                    id: "add_transactions_" + tableID,
                    role: "button",
                    tabindex: "0",
                    "aria-label": i18n.getTranslation('transaction_add_row') + table.name,
                    "tableID": tableID,
                }, [], `<i class="bi bi-plus-circle" tableID="${tableID}"></i> Add Row`),
                createElement("a", { // ada compliance updates - added
                    class: "btn btn-danger m-1 disabled", // default to disabled
                    id: "remove_transactions_" + tableID,
                    role: "button",
                    tabindex: "0",
                    "aria-label": i18n.getTranslation('transaction_delete_row'),
                    "tableID": tableID,
                }, [], `<i class="bi bi-dash-circle" tableID="${tableID}"></i> ${i18n.getTranslation('transaction_delete_row')}`),
            ])

            // ada compliance updates - added
            this.claim_transaction_row_buttons_events(add_row, table, tableTBODY, tableID, countRow);

            // Append the table to the fieldset
            fieldset.appendChild(divResponsiveTable);
            fieldset.appendChild(add_row);
        });

        return fieldset;
    }

    claim_transaction_row(table, tableTBODY, tableID, countRow) {
        const fieldsRow = createElement("tr", {
            class: "transaction-row", // ada compliance updates - added
            id: "transaction_row_" + tableID + "_" + countRow, // ada compliance updates - added
        });
        tableTBODY.appendChild(fieldsRow);
        let fieldID = 0;
        table.fields.forEach(field => {
            fieldID++;
            let td = createElement("td", { class: "transaction " + field.name, });
            let element = createElement("div");
            let validation = field.validation;
            let formInput = FormFields(field, "", fieldID, element, validation, fieldsRow);
            // set unique name for each field
            field.name = field.name + "__" + countRow;
            FormFieldsLabel(field, fieldID, element);
            // set unique id for each field
            formInput.id = formInput.id + "__" + countRow;
            // set item-id attribute
            formInput.setAttribute("item-id", countRow);
            if (formInput.type == 'number') {
                formInput.setAttribute('step', 'any');
                formInput.setAttribute('min', 0.01);
                if (tableID == 1) {
                    formInput.setAttribute('max', 5000);
                }
            }
            if (formInput.type == 'date') {
                formInput.setAttribute('max', new Date().toISOString().split('T')[0]);
                formInput.setAttribute('data-date-max', new Date().toISOString().split('T')[0]);
            }
            formInput.addEventListener('change', function() {
                validateField(formInput);
            });
            element.appendChild(formInput);
            td.appendChild(element);
            fieldsRow.appendChild(td);
        });
        return { tableTBODY, fieldsRow };
    }

    populate_claim_form(form, container, class_member, claim_deadline) {
        console.log("[populate_claim_form]");
        // set user for error tracking
        this.errorHandler.set_user({ id: class_member.zero_zero_id, email: class_member.email_address });
        // remove guard
        document.getElementById('guard').remove();
        // claim_deadline format December 31, 2024 at 04:00:00 P.M. 
        let deadlineSpan = uniformClaimDeadline(claim_deadline);
        // New Claim Form
        container.appendChild(this.claim_form(form, deadlineSpan));
        container.scrollIntoView({ behavior: "smooth" });
        // output
        outputDiv.appendChild(container);
        // hide loading gif
        loadingGif(loading, "hide", 250);
        document.getElementById('oop_expenses_0').closest('fieldset').appendChild(
            createElement("div", { id: 'section4_attestation', class: 'mt-3 p-3 border rounded bg-light' }, [
            createElement("h5", { class: 'mb-3 text-center fw-bold' }, [], 'ATTESTATION<br>(REQUIRED FOR DOCUMENTED LOSS PAYMENT CLAIMS ONLY)'),
            createElement("p", {}, [
                document.createTextNode('I, '),
                createElement("input", { type: 'text', class: 'form-control d-inline-block', style: 'width: 200px;', name: 'attestation_name', id: 'attestation_name', required: true, "data-validate": "required", "data-label": "Out-of-Pocket Loss Payment Attestation Name", placeholder: 'Name' }),
                createElement("label", { for: 'attestation_name'}, [], `<span class='error'></span>`),
                document.createTextNode(', declare that I suffered the Documented Losses claimed above.')
            ]),
            createElement("p", {}, [], 'I also attest that the Documented Losses claimed above are accurate and were not otherwise reimbursable by insurance.'),
            createElement("p", {}, [
                document.createTextNode('I declare under penalty of perjury under the laws of my home state that the foregoing is true and correct. Executed on '),
                createElement("input", { type: 'date', class: 'form-control d-inline-block', style: 'width: 150px;', name: 'attestation_date', id: 'attestation_date', required: true, "data-validate": "required", "data-label": "Out-of-Pocket Loss Payment Attestation Date", disabled: true }),
                createElement("label", { for: 'attestation_date'}, [], `<span class='error'></span>`),
                document.createTextNode(', in '),
                createElement("input", { type: 'text', class: 'form-control d-inline-block', style: 'width: 150px;', name: 'attestation_city', id: 'attestation_city', required: true, "data-validate": "required", "data-label": "Out-of-Pocket Loss Payment Attestation City", placeholder: 'City' }),
                createElement("label", { for: 'attestation_city'}, [], `<span class='error'></span>`),
                document.createTextNode(', '),
                createElement("select", { class: 'form-select d-inline-block', style: 'width: 150px;', name: 'attestation_state', id: 'attestation_state', required: true, "data-validate": "required", "data-label": "Out-of-Pocket Loss Payment Attestation State" }, [
                createElement("option", { value: "" }, [], "SELECT"),
                createElement("option", { value: "AL" }, [], "Alabama"),
                createElement("option", { value: "AK" }, [], "Alaska"),
                createElement("option", { value: "AZ" }, [], "Arizona"),
                createElement("option", { value: "AR" }, [], "Arkansas"),
                createElement("option", { value: "CA" }, [], "California"),
                createElement("option", { value: "CO" }, [], "Colorado"),
                createElement("option", { value: "CT" }, [], "Connecticut"),
                createElement("option", { value: "DE" }, [], "Delaware"),
                createElement("option", { value: "DC" }, [], "District Of Columbia"),
                createElement("option", { value: "FL" }, [], "Florida"),
                createElement("option", { value: "GA" }, [], "Georgia"),
                createElement("option", { value: "HI" }, [], "Hawaii"),
                createElement("option", { value: "ID" }, [], "Idaho"),
                createElement("option", { value: "IL" }, [], "Illinois"),
                createElement("option", { value: "IN" }, [], "Indiana"),
                createElement("option", { value: "IA" }, [], "Iowa"),
                createElement("option", { value: "KS" }, [], "Kansas"),
                createElement("option", { value: "KY" }, [], "Kentucky"),
                createElement("option", { value: "LA" }, [], "Louisiana"),
                createElement("option", { value: "ME" }, [], "Maine"),
                createElement("option", { value: "MD" }, [], "Maryland"),
                createElement("option", { value: "MA" }, [], "Massachusetts"),
                createElement("option", { value: "MI" }, [], "Michigan"),
                createElement("option", { value: "MN" }, [], "Minnesota"),
                createElement("option", { value: "MS" }, [], "Mississippi"),
                createElement("option", { value: "MO" }, [], "Missouri"),
                createElement("option", { value: "MT" }, [], "Montana"),
                createElement("option", { value: "NE" }, [], "Nebraska"),
                createElement("option", { value: "NV" }, [], "Nevada"),
                createElement("option", { value: "NH" }, [], "New Hampshire"),
                createElement("option", { value: "NJ" }, [], "New Jersey"),
                createElement("option", { value: "NM" }, [], "New Mexico"),
                createElement("option", { value: "NY" }, [], "New York"),
                createElement("option", { value: "NC" }, [], "North Carolina"),
                createElement("option", { value: "ND" }, [], "North Dakota"),
                createElement("option", { value: "OH" }, [], "Ohio"),
                createElement("option", { value: "OK" }, [], "Oklahoma"),
                createElement("option", { value: "OR" }, [], "Oregon"),
                createElement("option", { value: "PA" }, [], "Pennsylvania"),
                createElement("option", { value: "RI" }, [], "Rhode Island"),
                createElement("option", { value: "SC" }, [], "South Carolina"),
                createElement("option", { value: "SD" }, [], "South Dakota"),
                createElement("option", { value: "TN" }, [], "Tennessee"),
                createElement("option", { value: "TX" }, [], "Texas"),
                createElement("option", { value: "UT" }, [], "Utah"),
                createElement("option", { value: "VT" }, [], "Vermont"),
                createElement("option", { value: "VA" }, [], "Virginia"),
                createElement("option", { value: "WA" }, [], "Washington"),
                createElement("option", { value: "WV" }, [], "West Virginia"),
                createElement("option", { value: "WI" }, [], "Wisconsin"),
                createElement("option", { value: "WY" }, [], "Wyoming"),
                createElement("option", { value: "PR" }, [], "Puerto Rico"),
                createElement("option", { value: "GU" }, [], "Guam"),
                createElement("option", { value: "AS" }, [], "American Samoa"),
                createElement("option", { value: "MP" }, [], "Northern Mariana Islands"),
                createElement("option", { value: "VI" }, [], "U.S. Virgin Islands"),
                createElement("option", { value: "AA" }, [], "AA (Armed Forces Americas)"),
                createElement("option", { value: "AE" }, [], "AE (Armed Forces Europe)"),
                createElement("option", { value: "AP" }, [], "AP (Armed Forces Pacific)")
                ]),
                createElement("label", { for: 'attestation_state'}, [], `<span class='error'></span>`),
                document.createTextNode('.')
            ]),
            createElement("div", { class: 'mt-3' }, [
                createElement("input", { type: 'text', class: 'form-control', style: 'max-width: 300px;', name: 'attestation_signature', id: 'attestation_signature', placeholder: 'Signature', required: true, "data-validate": "required", "data-label": "Out-of-Pocket Loss Payment Attestation Signature" }),
                createElement("label", { for: 'attestation_signature'}, [], `<span class='error'></span>`),
            ])
            ])
        );

        // Load member data into form
        loadMember(class_member);
        // custom login member code
        document.getElementById('first_name').disabled = document.getElementById('first_name').value;
        document.getElementById('last_name').disabled = document.getElementById('last_name').value;
        if (!document.getElementById('oop_expenses_0').checked) {
            document.getElementById('transactions-1').classList.add('d-none');
            document.getElementById('section4_attestation').classList.add('d-none');
            document.getElementById('transactions-1').querySelectorAll('input, select, textarea').forEach((input) => {
                toggleFieldAttributeV2(input, 'required', false);
                input.toggleAttribute('required', false);
            });
            document.getElementById('section4_attestation').querySelectorAll('input, select, textarea').forEach((input) => {
                toggleFieldAttributeV2(input, 'required', false);
                input.toggleAttribute('required', false);
            });
        }
        // Payment widget 
        if (appPayMethod && appPayMethod !== "") {
            dstMember();
        }
        if (class_member.claim_id) {
            if (class_member?.claim_files?.length > 0) this.claim.prev_docs = true;
        } else {
            document.querySelectorAll('#contact-information input:not(#first_name):not(#last_name), #contact-information select, #contact-information textarea').forEach((input) => {
                input.value = '';
            });
        }
        // Init claim fields
        this.init_claim_fields(this.claim, form, claim_deadline);
    }

    init_claim_fields(claim, form, claim_deadline) {

        // Claim Inputs
        this.init_claim_inputs();

        // Loop thru available inputs
        this.init_claim_inputs_loop();

        // Validate phone number
        this.setup_phone_number_validation();

        // Country field toggle
        this.setup_country_field_toggle();

        // Confirm email address
        if (document.getElementById('email_address') && document.getElementById('confirm_email_address')) {
            ConfirmEmailAddress('init');
        }

        // Check for file documentation section
        if (document.getElementById('documentation')) {
            // Initialize file uploads
            this.init_claim_files(this.claim);
        }

        dstPaymentIframeTitle(form);

        if (Boolean(document.getElementById("form"))) {

            // ada compliance updates - added
            // TODO: review if this is where this belongs
            // if id="submit-claim" is clicked, add was-validated to form class
            document.getElementById("submit-claim").addEventListener('click', () => {
                document.getElementById("form").classList.add("was-validated");
            });

            document.getElementById("form").addEventListener('submit', (process) => {
                this.process_claim(process, this.claim, claim_deadline);
            });
        }

        document.getElementById('oop_expenses_0').addEventListener('click', function() {
            document.getElementById('transactions-1').classList.toggle('d-none', !this.checked);
            document.getElementById('section4_attestation').classList.toggle('d-none', !this.checked);
            document.getElementById('transactions-1').querySelectorAll('input, select, textarea').forEach((input) => {
                toggleFieldAttributeV2(input, 'required', this.checked);
                input.toggleAttribute('required', this.checked);
                if (!this.checked) input.value = '';
            });
            document.getElementById('section4_attestation').querySelectorAll('input, select, textarea').forEach((input) => {
                toggleFieldAttributeV2(input, 'required', this.checked);
                input.toggleAttribute('required', this.checked);
                if (!this.checked) input.value = '';
                if (this.checked && input.type == 'date') {
                    input.value = new Date().toISOString().split('T')[0];
                }
            });
        });

        loadingGif(loading, "hide", 1000);
    }

    init_claim_inputs() {
        let claimInputsContact = '#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url, #user_language, #ag_SGUID, #ag_TEST';
        let claimInputsFields = '#claim-fields input:not([item-id]), #claim-fields textarea:not([item-id]), #claim-fields select:not([item-id])';
        let claimInputsFieldsPayment = '#payment_method, #payment_token, #payment_email, #payment_phone';
        let claimInputsTransactions = 'input[item-id], select[item-id], textarea[item-id]';

        this.claim.inputs.contact = Array.from(document.querySelectorAll(claimInputsContact));
        this.claim.inputs.fields = Array.from(document.querySelectorAll(claimInputsFields + ', ' + claimInputsFieldsPayment));
        this.claim.inputs.transactions = Array.from(document.querySelectorAll(claimInputsTransactions));
    }

    process_claim(e, claim, deadline) {
        console.log("[process_claim]")

        /**
         * Prevent the default form submission.
         * 
         * @var {Event} e - The submit event object.
         * @returns {void}
         */
        e.preventDefault();

        /**
         * Disable the submit button to prevent multiple submissions.
         * 
         * Since: 2023.09.25
         * 
         * @returns {void}
         */
        document.getElementById('submit-claim').disabled = true;

        // var claim = this.claim;
        if (claim.flags.sent) {
            return;
        }

        clearMessage();

        claim.flags.valid = true;
        claim.data.fields = {};

        this.init_claim_inputs();

        this.format_claim_data(claim);

        claim.data.contact.date = localDatetime();

        if (document.getElementById('documentation')) {
            this.process_claim_files(this.claim);
        }

        if (document.getElementById('email_address') && document.getElementById('confirm_email_address')) {
            ConfirmEmailAddress('process', this.claim);
        }

        // // if appPayMethod is defined and not empty, we run dstProcess from FormBase/DigitalDisbursements.js
        // if (appPayMethod && appPayMethod !== "" && this.customDstProcess === null) {
        //     claim = dstProcess(this.claim);
        // }
        // else if (appPayMethod && appPayMethod !== "" && this.customDstProcess !== null) {
        //     claim = this.customDstProcess(this.claim);
        // }

        /**
         * Define the environment for the s3 uploader.
         */
        let s3env = this.config.url;

        let custom_errors = '';

        if (!document.getElementById('id_theft_protection_0').checked && !document.getElementById('oop_expenses_0').checked && !document.getElementById('cash_fund_payment_0').checked) {
            custom_errors += `<br>Please select at least one of options III or IV.`
            claim.flags.valid = false;
        }

        if (document.getElementById('oop_expenses_0').checked) {
            let total_claimed = 0.00;
            document.querySelectorAll('#transactions-1 input[type="number"]').forEach((input) => {
                total_claimed += parseFloat(input.value);
            });
            if (total_claimed > 5000) {
                custom_errors += `<br>Total out-of-pocket expenses cannot exceed $5,000.00.`
                claim.flags.valid = false;    
            }
        }

        let docs_uploaded = this.claim.prev_docs || claim.uploads.length > 0;
        if ((document.getElementById('oop_expenses_0').checked) && !docs_uploaded) {
            custom_errors += `<br>Please upload supporting documentation.`
            claim.flags.valid = false;
        }

        if (document.getElementById('oop_expenses_0').checked || document.getElementById('cash_fund_payment_0').checked) {
            if (!document.getElementById('payment_method') || !document.getElementById('payment_token') || !document.getElementById('payment_method').value || !document.getElementById('payment_token').value) {
                custom_errors += `<br>${i18n.getTranslation('payment_select_error')}`;
                claim.flags.valid = false;
            }

            if (document.getElementById('email_address').value && document.getElementById('payment_email').value && document.getElementById('email_address').value.toLowerCase() != document.getElementById('payment_email').value.toLowerCase()) {
                custom_errors += `<br>${i18n.getTranslation('claim_processing_email_error')}`;
                claim.flags.valid = false;
            }

            if (document.getElementById('phone_number_1').value && document.getElementById('payment_phone').value && document.getElementById('phone_number_1').value.replace(/\D/g, '') != document.getElementById('payment_phone').value.replace(/\D/g, '')) {
                custom_errors += `<br>${i18n.getTranslation('claim_processing_phone_error')}`;
                claim.flags.valid = false;
            }
        }

        if (claim.flags.valid) {
            grecaptcha.enterprise.execute(reCAPTCHAv3, { action: 'submit' }).then((token) => {
                claim.data.token = token;
                this.post_claim(claim, s3env);
            });
        } else {
            document.getElementById('submit-claim').disabled = false;
            var error = document.querySelector('label.error, #file-notice.error, #no-files.error');
            let timeout = 0;
            if (error && typeof error.scrollIntoView == 'function') {
                error.scrollIntoView({ behavior: "smooth" });
                timeout = 500;
            }
            setTimeout(() => {
                modal(i18n.getTranslation('error'), i18n.getTranslation('claim_form_errors') + custom_errors);
            }, timeout);
        }
    }
}
